export const SENDING_NUMBER_TASK_ID = "provision-sending-number";
export const CONFIGURE_PLAYBOOK_TASK_ID = "configure-playbook";

export const CONCIERGE_INTAKE_HERO_IMAGE_URL =
  "https://redoapi-dev.s3.us-east-1.amazonaws.com/redo/static/onboarding-v2/concierge_bell.webp";
